<div class="controls-container" *ngIf="currentProgress$ | async; let currentProgress">
    <p class="controls-title" *ngIf="!showPreviousExports && total > 0" i18n>Export all {{total}} {{itemLabels.plural}} to CSV</p>
    <p class="controls-title" *ngIf="showPreviousExports" i18n>Previous exports</p>
    <p class="controls-alert" *ngIf="!showPreviousExports && total === 0" i18n>Please select some {{itemLabels.plural}} before trying to export them to CSV.</p>

    <div *ngIf="!showPreviousExports">


      <div>
        <span *ngIf="['queued', 'inProgress'].includes(currentProgress.state)">
          <span *ngIf="currentProgress.value != -1">{{currentProgress.value}}%</span>
          <span *ngIf="currentProgress.value == -1">Queued</span>
          <mat-progress-bar [value]="currentProgress.value" [mode]="currentProgress.mode"></mat-progress-bar>
        </span>
      </div>

      <div *ngIf="['completed', 'none', 'aborted'].includes(currentProgress.state)">
        <mat-checkbox [(ngModel)]="options.exportOnlySelected" i18n>Export only selected columns</mat-checkbox>
      </div>

      <div class="controls-footer-buttons" *ngIf="{downloadable: downloadableExportId$ | async} as dwn">
        <button *ngIf="['completed', 'none', 'aborted'].includes(currentProgress.state)" mat-flat-button color="accent" (click)="onExport()">
          <span *ngIf="dwn.downloadable" i18n>New export</span>
          <span *ngIf="!dwn.downloadable" i18n>Export</span>
        </button>
        <button *ngIf="dwn.downloadable" mat-stroked-button color="accent" (click)="onDownloadLast(dwn.downloadable)" i18n>Download latest export</button>
        <button *ngIf="tableRows.length > 0" mat-stroked-button (click)="onSeePreviousExports()" i18n>See previous exports</button>
      </div>
    </div>

    <!-- This should be turned into SourceTable -->
    <div *ngIf="showPreviousExports && tableRows.length > 0">
        <mat-spinner *ngIf="tableRows.length === 0"></mat-spinner>
        <mat-table [dataSource]="tableRows">
            <ng-container *ngFor="let column of tableAllAvailableColumns" [matColumnDef]="column.id" >
                <mat-header-cell *matHeaderCellDef scope="col"> {{column.label}} </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.row[column.id] != undefined">
                        <ng-container [ngSwitch]="column.type">
                          <ng-container *ngSwitchCase="'date'">
                            {{ row.row[column.id] | date }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'dateRange'">
                            {{ row.row[column.id] | easDateRange }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'timeFromNow'">
                            {{ row.row[column.id] | easDateFromNow }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'price'">
                            <span *ngIf="row.row[column.id]">
                              {{ row[column.id]['amount'] | currency:row.row[column.id]['currency'] }}
                            </span>
                          </ng-container>
                          <ng-container *ngSwitchCase="'priceRange'">
                            {{ row.row[column.id] | easPriceRange:row.row[column.id].currency }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'datetime'">
                            {{ row.row[column.id] | date:'medium' }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'rate'">
                            {{ row.row[column.id] }}%
                          </ng-container>
                          <ng-container *ngSwitchCase="'link'">
                            <a [routerLink]="[row.row[column.id]?.relative]" [queryParams]="row.row[column.id]?.queryParams">{{ column.label }}</a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'button'">
                            <button mat-button color="accent" (click)="onClick(row.row[column.id])" [attr.aria-label]="column.label + ' ' + row.readableId">{{ row.row[column.id].label ?? column.label }}</button>
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            {{ row.row[column.id] }}
                          </ng-container>
                        </ng-container>
                      </ng-container>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="tableSelectedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableSelectedColumns;"></mat-row>
        </mat-table>
        <div class="controls-footer-buttons">
            <button mat-flat-button color="accent" (click)="onSeeNewExport()" i18n>Back</button>
        </div>
    </div>
</div>
